var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0C5.4775 0 0 5.4775 0 12.25C0 21.4375 12.25 35 12.25 35C12.25 35 24.5 21.4375 24.5 12.25C24.5 5.4775 19.0225 0 12.25 0ZM12.25 16.625C9.835 16.625 7.875 14.665 7.875 12.25C7.875 9.835 9.835 7.875 12.25 7.875C14.665 7.875 16.625 9.835 16.625 12.25C16.625 14.665 14.665 16.625 12.25 16.625Z",
    fill: "#2D9DC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 33.8611C11.9217 33.4792 11.4638 32.9368 10.9183 32.2647C9.77951 30.8615 8.26237 28.8972 6.74672 26.6508C5.22963 24.4023 3.7233 21.8847 2.59852 19.374C1.46933 16.8535 0.75 14.3951 0.75 12.25C0.75 5.89171 5.89171 0.75 12.25 0.75C18.6083 0.75 23.75 5.89171 23.75 12.25C23.75 14.3951 23.0307 16.8535 21.9015 19.374C20.7767 21.8847 19.2704 24.4023 17.7533 26.6508C16.2376 28.8972 14.7205 30.8615 13.5817 32.2647C13.0362 32.9368 12.5783 33.4792 12.25 33.8611ZM7.125 12.25C7.125 15.0792 9.42079 17.375 12.25 17.375C15.0792 17.375 17.375 15.0792 17.375 12.25C17.375 9.42079 15.0792 7.125 12.25 7.125C9.42079 7.125 7.125 9.42079 7.125 12.25Z",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2501,
    cy: 12.25,
    r: 5.08333,
    fill: "white",
    stroke: "#2D9DC9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOnline);
export default __webpack_public_path__ + "static/media/marker-online.66d4ed3aaccfd0c64b39e6054689f6de.svg";
export { ForwardRef as ReactComponent };